import { createBigDecimal } from '@0xtorch/big-decimal'
import type { Transfer } from '@0xtorch/core'
import type { z } from 'zod'
import type { LowerHex, TransactionDecoded } from '../../../../types'
import { createEvmAddressId } from '../../../../utils'
import { checkTransferIsMatchErc1155Pattern } from './erc1155Pattern'
import type { erc1155TransferGeneratorSchema } from './schema'

export const generateTransfersByErc1155Transfer = ({
  schema,
  transaction,
  relatedAddresses,
}: {
  readonly schema: z.infer<typeof erc1155TransferGeneratorSchema>
  readonly transaction: TransactionDecoded
  readonly relatedAddresses: Set<LowerHex>
}): readonly Transfer[] => {
  const transfers: Transfer[] = []
  let currentIndex = -1
  for (const transfer of transaction.erc1155Transfers) {
    const matched = checkTransferIsMatchErc1155Pattern({
      transfer,
      schema,
      transaction,
      relatedAddresses,
    })
    if (matched) {
      currentIndex += 1
      if (schema.index === undefined || currentIndex === schema.index) {
        transfers.push({
          direction: schema.direction,
          from: createEvmAddressId({
            chainId: transaction.chainId,
            address: transfer.from,
          }),
          to: createEvmAddressId({
            chainId: transaction.chainId,
            address: transfer.to,
          }),
          asset: transfer.token,
          amount: createBigDecimal(transfer.value),
        })
      }
      if (currentIndex === schema.index) {
        return transfers
      }
    }
  }
  if (schema.index === undefined) {
    return transfers
  }
  throw new Error('Matched ERC1155 transfer is not found')
}
